import React, { forwardRef } from 'react'
import clsx from 'clsx'
import PerfectScrollbar from 'react-perfect-scrollbar'
import { makeStyles } from '@material-ui/styles'
import { useDispatch, useSelector } from 'react-redux'
import useRouter from 'utils/useRouter'
import { Card, CardHeader, CardContent, CircularProgress, Grid, FormControl, Button, Divider, Typography } from '@material-ui/core'
import MaterialTable from 'material-table'
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos'
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward'
import SearchIcon from '@material-ui/icons/Search'
import ClearIcon from '@material-ui/icons/Clear'
import NavigateNextIcon from '@material-ui/icons/NavigateNext'
import NavigateBeforeIcon from '@material-ui/icons/NavigateBefore'
import FirstPageIcon from '@material-ui/icons/FirstPage'
import LastPageIcon from '@material-ui/icons/LastPage'
import { getLabelEndereco } from 'helpers/labels'
import moment from 'moment'
import localization from 'moment/locale/pt-br'
import { Link as RouterLink } from 'react-router-dom'
import EditIcon from '@material-ui/icons/Edit'

import { setIdExameSolicitado } from 'actions'

const useStyles = makeStyles((theme) => ({
  root: {},
  content: {
    padding: 0,
  },
  carregando: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    margin: 20,
  },
  inner: {
    minWidth: 700,
  },
  nameCell: {
    display: 'flex',
    alignItems: 'center',
  },
  avatar: {
    height: 42,
    width: 42,
    marginRight: theme.spacing(1),
  },
  actions: {
    padding: theme.spacing(1),
    justifyContent: 'flex-end',
  },
  divider: {
    margin: theme.spacing(2, 0),
  },
  item: {
    padding: theme.spacing(1),
  },
  list: {
    listStyle: 'none',
  },
}))

export const Results = (props) => {
  const { className, dados, carregando, ...rest } = props
  moment.locale('pt-br', localization)
  const classes = useStyles()
  const dispatch = useDispatch()
  const router = useRouter()

  const processandoSolicitacaoExame = useSelector((state) => state.solicitacaoExame.processandoSolicitacaoExame)

  const ListarObjetosPericiados = (rowData) => {
    const { objetos } = rowData
    if (objetos) {
      const { vests } = objetos
      const { perics } = objetos
      const { cadavs } = objetos
      const { locais } = objetos
      return (
        <ul className={classes.list}>
          {vests.map((vestigio) => (
            <li>Vestígio {vestigio.identificador}</li>
          ))}
          {perics.map((periciando) => (
            <li>Periciando {periciando.cpf}</li>
          ))}
          {cadavs.map((cadaver) => (
            <li>Cadáver {cadaver.nic}</li>
          ))}
          {locais.map((local) => (
            <li> {getLabelEndereco(local)}</li>
          ))}
        </ul>
      )
    }
    return null
  }

  const handleClickSolicitacaoExame = (rowData) => {
    router.history.push(`/casos/caso/solicitacao/exameSolicitado/detalhar/${rowData.id}`)
  }

  return (
    <div>
      <div {...rest} className={clsx(classes.root, className)}>
        <Card {...rest} className={clsx(classes.root, className)}>
          {processandoSolicitacaoExame ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <CardContent>
              <div>
                <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
                  <Grid item>
                    <CardHeader title="Dados gerais" />
                  </Grid>
                  <Grid item>
                    <Button component={RouterLink} to="/casos/caso/solicitacao/editar" color="secondary" variant="contained">
                      <EditIcon className={classes.addIcon} />
                      Editar solicitação de exames
                    </Button>
                  </Grid>
                </Grid>
                <Divider className={classes.divider} />
              </div>
              <Grid className={classes.fieldGroup} alignItems="center" container justify="space-between">
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <FormControl
                    style={{
                      minWidth: '100%',
                      maxWidth: '100%',
                    }}
                  >
                    <Typography variant="h5">
                      Solicitante:
                      {dados.solicitacao ? `${dados.autReq.nome} ${dados.autReq.sobrenome} - ${dados.autReq.matricula}` : null}
                    </Typography>{' '}
                    <Typography variant="body1">Processo SEI: {dados.processoSei ? dados.processoSei : null}</Typography>
                    <Typography variant="body1">Data: {dados.data ? moment(dados.data).format('LLLL') : null}</Typography>
                  </FormControl>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <FormControl
                    style={{
                      minWidth: '100%',
                      maxWidth: '100%',
                    }}
                  >
                    <Typography variant="h5">{dados.tipoSol ? dados.tipoSol : null}</Typography>
                    <Typography variant="body1">{dados.endereco ? dados.endereco : null}</Typography>
                  </FormControl>
                </Grid>
                <Grid className={classes.item} item md={4} sm={4} xs={12}>
                  <FormControl
                    style={{
                      minWidth: '100%',
                      maxWidth: '100%',
                    }}
                  >
                    <Typography variant="h5">Destino do laudo: {dados.setDest ? dados.setDest.nome : null}</Typography> <Typography variant="body1">Observações: {dados.observacoes ? dados.observacoes : null}</Typography>
                  </FormControl>
                </Grid>
              </Grid>
            </CardContent>
          )}
        </Card>
      </div>
      <div {...rest} className={clsx(classes.root, className)}>
        <Card>
          {carregando ? (
            <div className={classes.carregando}>
              <CircularProgress disableShrink />
            </div>
          ) : (
            <CardContent>
              <div>
                <Grid alignItems="flex-end" container justify="space-between" spacing={3}>
                  <Grid item>
                    <CardHeader title="Exames solicitados" />
                  </Grid>
                </Grid>
                <Divider className={classes.divider} />
              </div>
              <PerfectScrollbar>
                <div className={classes.inner}>
                  <MaterialTable
                    localization={{
                      pagination: {
                        labelDisplayedRows: '{from}-{to} de {count}',
                        labelRowsSelect: 'linhas',
                        nextTooltip: 'Página seguinte',
                        previousTooltip: 'Página anterior',
                        lastTooltip: 'Última página',
                        firstTooltip: 'Primeira página',
                      },
                      toolbar: {
                        nRowsSelected: '{0} linha(s) selecionadas',
                        searchPlaceholder: 'Buscar',
                      },
                      header: {
                        actions: 'Ações',
                      },
                      body: {
                        emptyDataSourceMessage: 'Nada para mostrar',
                        filterRow: {
                          filterTooltip: 'Filtro',
                        },
                      },
                    }}
                    title=""
                    columns={[
                      {
                        title: 'Exame',
                        field: 'tipoEx.nome',
                      },
                      {
                        title: 'Setor responsável',
                        field: 'setor.nome',
                      },
                      {
                        title: 'Objetos de perícia',
                        render: (rowData) => <ListarObjetosPericiados objetos={rowData} />,
                      },
                    ]}
                    data={dados.exSols}
                    onRowClick={(event, rowData) => handleClickSolicitacaoExame(rowData)}
                    options={{
                      actionsColumnIndex: -1,
                      search: true,
                      pageSize: 5,
                      searchFieldStyle: {
                        flexGrow: 1,
                        height: 42,
                        // padding: theme.spacing(0, 2),
                        display: 'flex',
                        alignItems: 'center',
                      },
                      headerStyle: {
                        backgroundColor: '#f4f6f8',
                      },
                      toolbar: false,
                    }}
                    icons={{
                      DetailPanel: forwardRef((propsDetailPanel, ref) => <ArrowForwardIosIcon {...propsDetailPanel} ref={ref} />),
                      SortArrow: forwardRef((propsSortArrow, ref) => <ArrowDownwardIcon {...propsSortArrow} ref={ref} />),
                      Search: forwardRef((propsSearch, ref) => <SearchIcon {...propsSearch} ref={ref} />),
                      ResetSearch: forwardRef((propsResetSearch, ref) => <ClearIcon {...propsResetSearch} ref={ref} />),
                      NextPage: forwardRef((propsNextPage, ref) => <NavigateNextIcon {...propsNextPage} ref={ref} />),
                      PreviousPage: forwardRef((propsPreviousPage, ref) => <NavigateBeforeIcon {...propsPreviousPage} ref={ref} />),
                      FirstPage: forwardRef((propsFirstPage, ref) => <FirstPageIcon {...propsFirstPage} ref={ref} />),
                      LastPage: forwardRef((propsLastPage, ref) => <LastPageIcon {...propsLastPage} ref={ref} />),
                    }}
                    style={{
                      padding: '16px',
                      fontSize: '14px',
                      textAlign: 'left',
                      fontFamily: 'Roboto, Helvetica, Arial, sans-serif',
                      fontWeight: '400',
                      lineHeight: '21px',
                      borderBottom: '1px solid #eeeeee',
                      letterSpacing: '-0.05px',
                      verticalAlign: 'inherit',
                    }}
                  />
                </div>
              </PerfectScrollbar>
            </CardContent>
          )}
        </Card>
      </div>
    </div>
  )
}
